import { unwrapResult } from '@reduxjs/toolkit';
import { useAppSelector } from 'hooks';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { AppDispatch } from 'redux/store';
import { defaultProjectUpdateQuery } from './default-project-update.selector';
import { defaultProjectUpdateActions } from './default-project-update.slice';

export const useDefaultProjectUpdateFacade = () => {
  const dispatch: AppDispatch = useDispatch();

  const processing = useAppSelector(defaultProjectUpdateQuery.getProcessing);

  const updateDefaultProject = useCallback(
    (projectId: string) => dispatch(defaultProjectUpdateActions.updateDefaultProject({ projectId })).then(unwrapResult),
    [dispatch],
  );

  return {
    processing,
    updateDefaultProject,
  };
};
